<template>
  <div>
    <PageTitle title="Kitchen Stock Reports" />
    <v-container fluid class="lighten-12 content">
      <v-card class="lighten-12 card-content">
        <TableFilters
          :filters="['kitchen', 'unit', 'search']"
          :columns="columns"
          v-model="filter"
          :export="[`productexport`]"
          @clear="onClearFilters"
        ></TableFilters>
        <v-row class="py-0 my-0">
          <v-col cols="12" class="py-0 my-0">
            <v-row class="py-0 my-0">
              <v-col cols="auto" class="py-1 pr-2">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      depressed
                      v-bind="attrs"
                      v-on="on"
                      shaped
                      block
                      height="30px"
                      class="report-button"
                      color="blue"
                      @click="
                        generateReport();
                        hide = true;
                      "
                    >
                      <v-icon small>mdi-file-send </v-icon>Generate
                    </v-btn>
                  </template>
                  <span>Genarate</span>
                </v-tooltip>
              </v-col>
              <v-col cols="auto" class="py-1 pr-2" v-if="hide"><v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }"
                    ><v-btn
                      depressed
                      v-bind="attrs"
                      v-on="on"
                      class="report-button"
                      color="red"
                      height="30px"
                      block
                      @click="exportPDF()"
                    >
                      <v-icon small>mdi-file-pdf </v-icon>Export
                    </v-btn>
                  </template>
                  <span>Export to PDF</span>
                </v-tooltip></v-col
              >
              <v-col cols="auto" class="py-1 pr-2" v-if="hide">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      height="30px"
                      v-bind="attrs"
                      v-on="on"
                      block
                      class="report-button"
                      color="green"
                      @click="exceldownload()"
                    >
                      <v-icon small>mdi-file-excel </v-icon>Export
                    </v-btn>
                  </template>
                  <span>Export to Excel</span>
                </v-tooltip></v-col
              >
            </v-row>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="mt-2">
        <v-container fluid>
          <v-row>
            <v-card-text class="pa-0">
              <v-data-table
                 :v-model:options="pagination"
                :items-per-page="pagination.itemsPerPage"
                :items-per-page-options="[5, 10, 20, 50, 100, 1000, -1]"
                :fixed-header="true"
                :headers="headers"
                :items="kitchenstock"
                item-key="id"
                class="row-pointer product-list"
                id="indextable"
              >
                <!-- <template v-slot:item.code="{ item }">
                  <CopyTableCell :text="item.code"></CopyTableCell>
                </template> -->
                <!-- No -->

                <!-- Image -->
                <!-- <template v-slot:item.image="{ item }">
                  <img
                    v-if="item.image"
                    :src="item.image"
                    height="32"
                    width="32"
                    class="image"
                  />
                  <v-avatar v-else size="32px" item color="primary">
                    <span class="white--text subtitle-2 text-uppercase">
                      {{ item.name.substring(0, 2) }}</span
                    >
                  </v-avatar>
                </template> -->

                <!-- Category -->
                <template v-slot:item.product_name="{ item }">{{
                  item.product && item.product.name ? item.product.name : "-"
                }}</template>
                
                <template v-slot:item.product_code="{ item }">{{
                  item.product && item.product.code ? item.product.code : "-"
                }}</template>
                
                <template v-slot:item.product_reference="{ item }">{{
                  item.product && item.product.reference_number ? item.product.reference_number : "-"
                }}</template>
                
                <template v-slot:item.unit="{ item }">{{
                  item.unit && item.unit.name ? item.unit.name : "-"
                }}</template>

                <template v-slot:item.kitchen="{ item }">{{
                  item.kitchen && item.kitchen.name ? item.kitchen.name : "-"
                }}</template>
              </v-data-table>
            </v-card-text>
          </v-row>
        </v-container>
      </v-card>
      <div class="d-flex justify-center align-center"></div>
      <!-- </v-row> -->
    </v-container>
  </div>
</template>

<script>
// Components
import PageTitle from "@/components/shared/PageTitle";
import TableFilters from "@/components/base/TableFilters";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import XLSX from "xlsx";
import { DateTime } from "@grapecity/wijmo";
import moment from "moment";
import _ from "lodash";
export default {
  data: () => ({
    columns: [
      {
        text: "Number",
        value: "no",
        show: true,
        disabled: false,
        width: "14%",
      },
      {
        text: "Name",
        value: "product_name",
        show: true,
        disabled: false,
        width: "14%",
      },
      {
        text: "Code",
        value: "product_code",
        show: true,
        disabled: false,
        width: "14%",
      },
      {
        text: "Reference Number",
        value: "product_reference",
        show: true,
        disabled: false,
        width: "14%",
      },
      {
        text: "Unit",
        value: "unit",
        show: true,
        disabled: false,
        width: "14%",
      },
      {
        text: "Kitchen",
        value: "kitchen",
        show: true,
        disabled: false,
        width: "14%",
      },
      {
        text: "Available Stock",
        value: "available_stock",
        show: true,
        disabled: false,
        width: "14%",
      },
      {
        text: "Amount",
        value: "amount",
        show: true,
        disabled: false,
        width: "14%",
      },
    ],
    pagination: {
    page: 1,
    itemsPerPage: -1,
  },
    kitchenstock: [],
    // Filters
    filter: {
      kitchen: "",
      search: "",
    },
  }),
  components: {
    PageTitle,
    TableFilters,
  },

  mounted() {
    this.generateReport();
  },

  methods: {
    generateReport() {
      var filter = this.filter;
      this.$store
        .dispatch("report/getKitchenStockReports", filter)
        .then((res) => {
          let i = 1;
          this.kitchenstock = res.data.data;
          this.kitchenstock.map((p) => {
            p.no = i;
            i++;
          });
        })
        .catch((err) => {
          this.isLoading = false;
          this.messages = err.data.title;
        });
    },
    exportPDF() {
      const today = new DateTime();
      let Data = _.cloneDeep(this.kitchenstock);
      for (let x = 0; x < Data.length; x++) {
        Data[x].product_name = Data[x].product.name;
        Data[x].product_code = Data[x].product.code;
        Data[x].product_reference = Data[x].product.reference_number;

        Data[x].unit = Data[x].unit.name;
        Data[x].kitchen = Data[x].kitchen.name;
      }
      var rows = Data;
      var doc = jsPDF({
        orientation: "landscape",
      });
      doc.setFontSize(14);
      // doc.setFontType("bold");
      doc.setTextColor(26, 26, 26);
      doc.setFont("helvetica", "bold");
      doc.text("Kitchen Stock Report", 15, 5);

      doc.setFontSize(11);
      doc.text(15, 12, `${moment(today).format("DD-MM-YYYY HH:MM:SS")}`);

      doc.autoTable(
        this.headers.map((h) => {
          return { title: h.text, dataKey: h.value };
        }),
        rows,
        {
          didParseCell: function(data) {
            if (data.column.dataKey === "addsress") {
              data.cell.text = data.cell.raw.country;
            }
          },
        }
      );
      doc.save(`${moment(today).format("DD-MM-YYYY")}-kitchenstock.pdf`);
    },
    //Product Details Export Excel
    exceldownload() {
      var data = document.getElementById("indextable");
      const today = new DateTime();
      const headData = XLSX.utils.table_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        wb,
        headData,
        moment(today).format("DD-MM-YYYY")
      );
      XLSX.writeFile(
        wb,
        `${moment(today).format("DD-MM-YYYY")}-kitchenstock.xlsx`
      );
    },
    onClearFilters() {
      this.kitchenstock = [];
      this.hide = false;

      this.$nextTick(() => {
        this.generateReport();
      });
    },
  },
  computed: {
    headers: function() {
      return this.columns.filter((item) => item.show == true);
    },
  },
};
</script>
